import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, getsubdomainType,addData, updateData, deleteData } from '../../../services/admin/cmsUser/cmsUserServices';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Select from 'react-select';
import { v4 as uuidv4 } from 'uuid';

const CmsUser = () => {
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ 
    id: '', 
    username: '',
    password: '',
    email: '',
    sub_domain: '',
    private_key:''
  });
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  console.log('selectedData',selectedData);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');
  const[showPassword, setShowPassword] = useState(false);
  const [subdomainTypes, setsubdomainTypes] = useState([]);

  
  // Fetch data list
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getData();
      setDataList(data);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch data:', error);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const fetchsubdomainType = async () => {
      try {
        const data = await getsubdomainType(); // Fetch data from the service
        setsubdomainTypes(data); // Set the types in state
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchsubdomainType();
  }, []);


  const options = subdomainTypes.map(sub_domain_type => ({
    value: sub_domain_type.sub_domain,
    label: sub_domain_type.sub_domain
  }));

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value.trim() }));

    // Clear error when user types
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  // Form validations
  const validateForm = () => {
    const newErrors = {};
    
    if (!form.username.trim()) {
      newErrors.username = 'Username is required';
    }
    
    if (modalType === 'add' && !form.password) {
      newErrors.password = 'Password is required';
    } else if (form.password && form.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }
    
    if (!form.email) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    else {
      const emailExists = dataList.some(
        (entry) =>
          entry.email.toLowerCase() === form.email.trim().toLowerCase() &&
          entry.id !== form.id // allow same email if editing current record
      );
    
      if (emailExists) {
        newErrors.email = 'This email already exists';
      }
    }
      

    if (!form.sub_domain) {
      newErrors.sub_domain = 'Please select a sub-domain';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
// generate 16 digit token
 const generatePrivateKey = () => {
  return uuidv4().replace(/-/g, '').slice(0, 16); // 16-character strong token
};

  useEffect(() => {
    setForm(prev => ({
      ...prev,
      private_key: generatePrivateKey()
    }));
  }, [!form.private_key]);

  const handleSubmit = async () => {
    try {
      setSubmitError('');
      if (!validateForm()) return;

      if (modalType === 'add') {
        await addData(form);
      } else if (modalType === 'edit') {
        await updateData(form);
      }
      fetchData();
      setShowModal(false);
    } catch (error) {
      console.error('Error during form submission:', error);
      setSubmitError(error.message || 'Failed to save data. Please try again.');
    }
  };

  const handleDelete = async () => {
    try {
      if (selectedData) {
        setLoading(true);
        await deleteData(selectedData.id);
        setLoading(false);
        fetchData();
        setShowDeleteConfirmModal(false);
      }
    } catch (error) {
      console.error('Error deleting data:', error);
      setSubmitError('Failed to delete. Please try again.');
    }
  };

  const openModal = (type, data = { id: '', username: '', password: '', email: '', sub_domain: '' }) => {
    setLoading(true);
    setModalType(type);
    setForm(data);
    setErrors({});
    setSubmitError('');
    
    setTimeout(() => {
      setShowModal(true);
      setLoading(false);
    }, 100); // Delay just enough to show spinner
  };

  const openDeleteConfirmModal = (data) => {
    setLoading(true);
    setSelectedData(data);
    setSubmitError('');
    setTimeout(() => {
      setShowDeleteConfirmModal(true);
      setLoading(false);
    }, 100);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    return dataList.filter(data =>
      data.username.toLowerCase().includes(searchText.toLowerCase()) ||
      data.email.toLowerCase().includes(searchText.toLowerCase()) ||
      data.sub_domain.toLowerCase().includes(searchText.toLowerCase())
    )
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)); // Descending by updatedAt
  }, [dataList, searchText]);

  const columns = [
    {
      name: '#',
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: '80px',
    },
    {
      name: 'Username',
      selector: row => row.username,
      sortable: true,
      cell: row => (
        <div title={row.username} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 200 }}>
          {row.username}
        </div>
      )

    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true,
      cell: row => (
        <div title={row.email} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 200 }}>
          {row.email}
        </div>
      )
    },
    {
      name: 'SubDomain',
      selector: row => row.sub_domain,
      sortable: true,
      cell: row => (
        <div title={row.sub_domain} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 200 }}>
          {row.sub_domain}
        </div>
      )
    },
    {
      name: 'Updated At',
      selector: row => new Date(row.updatedAt).toLocaleString(),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: row => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)}>
            Edit
          </Button>
          <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)}>
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
            <Spinner />
          </div>
        ) : (
          <div>
            <div className="container-fluid p-4">
              <div className="row">
                <div className="col-8">
                  <p className="fs-4">CMS Login Configuration</p>
                </div>
                <div className="col-4 text-end">
                  <Button variant="primary" onClick={() => openModal('add')}>
                    Add User
                  </Button>
                </div>
              </div>

              {submitError && <Alert variant="danger">{submitError}</Alert>}

              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                paginationPerPage={10}
                highlightOnHover
                responsive
                striped
                onChangePage={handlePageChange}
                subHeader
                subHeaderComponent={
                  <Form.Control
                    type="text"
                    placeholder="Search by username, email or sub_domain"
                    value={searchText}
                    onChange={handleSearchChange}
                    className="m-3"
                  />
                }
              />

              {/* Add/Edit Modal */}
              <Modal show={showModal} backdrop="static" onHide={() => setShowModal(false)} size="md">
                <Modal.Header closeButton>
                  <Modal.Title>{modalType === 'add' ? 'Add New CmsUser' : 'Edit CmsUser'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {submitError && <Alert variant="danger">{submitError}</Alert>}
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>UserName <span className='text-danger'> * </span></Form.Label>
                      <Form.Control
                        type="text"
                        name="username"
                        value={form.username}
                        onChange={handleChange}
                        isInvalid={!!errors.username}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.username}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Email <span className='text-danger'> * </span></Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        isInvalid={!!errors.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        Password  <span className='text-danger'> * </span> {modalType === 'edit' && '(Leave blank to keep current)'}
                      </Form.Label>
                      <div style={ {position: 'relative'} }>
                      <Form.Control
                        type={showPassword?"text":"password"}
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        isInvalid={!!errors.password}
                      />
                       <span
                          onClick={() => setShowPassword(!showPassword)}
                          style={{
                            position: 'absolute',
                            top: '50%',
                            right: '10px',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 2
                          }}
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>

                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                          SubDomain <span className="text-danger">*</span>
                        </Form.Label>
                        <Select
                          name="sub_domain"
                          value={options.find(opt => opt.value === form.sub_domain)}
                          onChange={(selectedOption) =>
                            handleChange({
                              target: { name: 'sub_domain', value: selectedOption?.value || '' }
                            })
                          }
                          options={options}
                          className={errors.sub_domain ? 'is-invalid' : ''}
                        />
                        {errors.sub_domain && (
                          <div className="invalid-feedback d-block">{errors.sub_domain}</div>
                        )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        Private Key <span className="text-danger">*</span>
                      </Form.Label>
                      <div style={{ position: 'relative' }}>
                        <Form.Control
                          type="text"
                          name="private_key"
                          value={form.private_key}
                          readOnly
                          disabled
                        />
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          style={{
                            position: 'absolute',
                            top: '50%',
                            right: '10px',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 2,
                            borderRadius:'4px'
                          }}
                          onClick={() => {
                            navigator.clipboard.writeText(form.private_key);
                            alert('Private key copied!');
                          }}
                        >
                          Copy
                        </Button>
                      </div>
                    </Form.Group>
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowModal(false)}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={handleSubmit}>
                    {modalType === 'add' ? 'Add CmsUser' : 'Save'}
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Delete Confirmation Modal */}
              <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {submitError && <Alert variant="danger">{submitError}</Alert>}
                  <p>Are you sure you want to delete user: <strong>{selectedData?.username}</strong>?</p>
                  <p className="text-danger">This action cannot be undone.</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                    Cancel
                  </Button>
                  <Button variant="danger" onClick={handleDelete}>
                    Delete
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
            <Footer />
          </div>
        )}
      </div>
    </div>
  );
};

export default CmsUser;